import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Factory, Loader2 } from "lucide-react";

export default function AmelLoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (ex) {
      setErr(ex.message || "Autentificare esuata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="h-14 w-14 rounded-xl bg-amber-500 flex items-center justify-center shadow-md mb-4">
            <Factory className="h-8 w-8 text-white" />
          </div>
          <div className="text-slate-900 font-bold text-2xl tracking-tight">AmelProd</div>
          <div className="text-slate-500 text-xs uppercase tracking-widest mt-1">Documente productie</div>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-xl p-6 shadow-lg border border-slate-200 space-y-4"
          data-testid="login-form"
        >
          <div>
            <label className="block text-slate-700 text-sm mb-1.5 font-medium">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full rounded-md bg-white border border-slate-300 text-slate-900 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-colors"
              placeholder="email@amel.ro"
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm mb-1.5 font-medium">Parola</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full rounded-md bg-white border border-slate-300 text-slate-900 px-3 py-2.5 text-sm focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-colors"
              placeholder="parola"
            />
          </div>

          {err && (
            <div className="text-red-600 text-sm bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="login-error">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full rounded-md bg-amber-500 hover:bg-amber-600 text-white font-semibold py-2.5 text-sm transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Autentificare
          </button>
        </form>
      </div>
    </div>
  );
}
